import { useTranslation } from 'react-i18next'

import {
  Alert,
  DangerButton,
  TertiaryButton,
  Text,
  VStack,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  /** 削除対象のサマリ (AC-BSP-139)。 undefined ならモーダルは閉じている。 */
  summary: string | undefined
  isOpen: boolean
  isSubmitting: boolean
  errorMessage: string | undefined
  onClose: () => void
  onConfirm: () => void
}

/**
 * 札の削除確認モーダル (design `spot.html` `#row-delete-modal`)。
 * 削除は親が当日 request の Update (該当札を除外した全置換) で実行する。
 */
export const DeleteBidConfirmModal = ({
  summary,
  isOpen,
  isSubmitting,
  errorMessage,
  onClose,
  onConfirm,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Modal
      footer={
        <>
          <TertiaryButton marginRight={3} onClick={onClose}>
            {t('common:action.cancel')}
          </TertiaryButton>
          <DangerButton loading={isSubmitting} onClick={onConfirm}>
            {t('common:action.delete')}
          </DangerButton>
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title={t('page:biddingSpot.modal.deleteBidTitle')}
    >
      <VStack align="stretch" gap={3}>
        {errorMessage !== undefined && (
          <Alert status="error" title={errorMessage} />
        )}
        {summary !== undefined && <Text>{summary}</Text>}
      </VStack>
    </Modal>
  )
}
